import React from 'react';

const Badge: React.FC<{ className?: string; 'data-testid'?: string }> = ({
  children,
  className,
  ...rest
}) => {
  return (
    <div
      className={`dib f8 sans-serif bg-white ba b--light-gray br-pill ph3 pv1 ${className}`}
      {...rest}
    >
      {children}
    </div>
  );
};

export default Badge;
